import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sparkles, Menu, X } from "lucide-react";
import { useState } from "react";

export function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/templates", label: "Templates" },
    { to: "/reminders", label: "Occasion Planner" },
    { to: "/advertise", label: "Advertise" },
  ];

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FDFBF7]/85 border-b-2 border-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 font-display font-bold text-xl">
          <span className="grid place-items-center w-9 h-9 rounded-xl bg-[#FFB5A7] border-2 border-[#0A0A0A]">
            <Sparkles className="w-5 h-5" />
          </span>
          SendOccasions
          <span className="ml-1 text-[10px] font-bold uppercase tracking-widest bg-[#A8E6CF] border-2 border-[#0A0A0A] rounded-md px-1.5 py-0.5">Beta</span>
        </Link>

        <nav className="hidden md:flex items-center gap-2">
          {links.map((l) => {
            const highlight = l.label === "Occasion Planner";
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 font-semibold rounded-xl transition-all border-2 ${
                  highlight
                    ? "bg-[#8AC6FF] border-[#0A0A0A] shadow-[2px_2px_0px_#0A0A0A] hover:-translate-y-0.5 hover:shadow-[3px_3px_0px_#0A0A0A]"
                    : "border-transparent hover:bg-[#F9F871]"
                }`}
              >
                {l.label}
              </Link>
            );
          })}
          {user ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="px-4 py-2 font-semibold rounded-xl hover:bg-[#F9F871] transition-colors">
                Dashboard
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="px-4 py-2 font-semibold rounded-xl hover:bg-[#A8E6CF] transition-colors">
                  Admin
                </Link>
              )}
              <button
                data-testid="nav-logout"
                onClick={() => { logout(); navigate("/"); }}
                className="nb-btn bg-white px-4 py-2"
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="px-4 py-2 font-semibold rounded-xl hover:bg-[#F9F871] transition-colors">
                Log in
              </Link>
              <Link to="/signup" data-testid="nav-signup" className="nb-btn bg-[#FFB5A7] px-4 py-2">
                Sign up free
              </Link>
            </>
          )}
        </nav>

        <button data-testid="nav-mobile-toggle" className="md:hidden nb-btn bg-white w-10 h-10 p-0" onClick={() => setOpen(!open)}>
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-[#0A0A0A] bg-[#FDFBF7] px-5 py-4 flex flex-col gap-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
              className={`px-4 py-3 font-semibold rounded-xl ${l.label === "Occasion Planner" ? "bg-[#8AC6FF] border-2 border-[#0A0A0A]" : "hover:bg-[#F9F871]"}`}>
              {l.label}
            </Link>
          ))}
          {user ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)} className="px-4 py-3 font-semibold rounded-xl hover:bg-[#F9F871]">Dashboard</Link>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="px-4 py-3 font-semibold rounded-xl hover:bg-[#A8E6CF]">Admin</Link>}
              <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="nb-btn bg-white px-4 py-3">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="px-4 py-3 font-semibold rounded-xl hover:bg-[#F9F871]">Log in</Link>
              <Link to="/signup" onClick={() => setOpen(false)} className="nb-btn bg-[#FFB5A7] px-4 py-3">Sign up free</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
